import { UpdateCartQuantityAction } from './types';

export const UPDATE_CART_QUANTITY = 'UPDATE_CART_QUANTITY';

export const UPDATE_CART_CROSS_SELL_QUANTITY =
  'UPDATE_CART_CROSS_SELL_QUANTITY';

export const updateCartItemsQuantity = (
  quantity: number
): UpdateCartQuantityAction => ({
  type: UPDATE_CART_QUANTITY,
  quantity: quantity
});

export const updateCartCrossSellQuantity = (
  quantity: number
): Omit<UpdateCartQuantityAction, 'quantity'> => ({
  type: UPDATE_CART_CROSS_SELL_QUANTITY,
  crossSellQuantity: quantity
});
